
<app-incidents 
#incidents 
[enableSelectedRows]="true" 
[enableRowActions]="false" 
(onSelectedIncident)="onSelectedIncident($event)"
[enableUpdateFilterButton]="false"
[enableDisplayFilter]="false"
[paramsFilter]="_params"
></app-incidents>